import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const setActiveUserContext = React.createContext({});
export let setActiveUserMachine: any;

const MODULE_NAME = 'machines.setActiveUser';

export const useSMSetActiveUser = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  setActiveUserMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(setActiveUserMachine);

  return {
    setActiveUserMachine,
    setActiveUserState: state,
    setActiveUserSend: send,
  };
};
